export default "__VITE_ASSET__iXIUOOPH__"